import { render, staticRenderFns } from "./over-pay-card.vue?vue&type=template&id=5c4dd399&scoped=true&"
import script from "./over-pay-card.vue?vue&type=script&lang=js&"
export * from "./over-pay-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4dd399",
  null
  
)

export default component.exports